// File: src/blueprint/state/useSessionStatus.js

/**
 * GOAL:
 * - Provide entry/session status for the runner (first/resume/expired).
 * - MVP stubbed implementation to unblock UI development.
 *
 * OUT OF SCOPE (for now):
 * - Redeeming OTP/magic link.
 * - Server validation, expiry, reactivation flows.
 *
 * NOTES:
 * - Keep return shape stable as we later swap in a real implementation.
 */

import { useMemo } from 'react';

export function useSessionStatus() {
  return useMemo(() => {
    return { mode: 'first' };
  }, []);
}
